const CLICK_OVERVIEW = 'Click Overview';
const CLICK_DETAILS_ON_INSPECTIONS_CARD = 'Click on Details on the Safety Inspections Card';
const CLICK_DETAILS_ON_TRAININGS_CARD = 'Click on Details on the Safety Trainings Card';
const CLICK_DETAILS_ON_OBSERVATIONS_CARD = 'Click on Details on the Observations Card';
const CLICK_OPEN_INCIDENTS = 'Click on Open Incidents Ribbon';
const CLICK_AWAITING_REVIEW = 'Click on Awaiting Review Ribbon';
const CLICK_REVIEWED_INCIDENTS = 'Click on Reviewed Incidents Ribbon';
const CLICK_DETAILS_ON_JSA_REVIEW_CARD = 'Click on Details on the JSA Review Card';
const SAFETY_COMPLETED_TRAININGS_PRINTED = 'Safety Completed Trainings Printed';
const CLICK_SAFETY_TRAINING_MEETING_DUPLICATED = 'Click on Safety Training Meeting Duplicated';

const safetyAnalyticConstant = {
  CLICK_OVERVIEW,
  CLICK_DETAILS_ON_INSPECTIONS_CARD,
  CLICK_DETAILS_ON_TRAININGS_CARD,
  CLICK_DETAILS_ON_OBSERVATIONS_CARD,
  CLICK_OPEN_INCIDENTS,
  CLICK_AWAITING_REVIEW,
  CLICK_REVIEWED_INCIDENTS,
  CLICK_DETAILS_ON_JSA_REVIEW_CARD,
  SAFETY_COMPLETED_TRAININGS_PRINTED,
  CLICK_SAFETY_TRAINING_MEETING_DUPLICATED,
};
export default safetyAnalyticConstant;
